import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Casting Table (physical table on the production floor)
 */
export interface StructureCastCastingTable {
  id: string;
  name: string;
  tableType: "post_form" | "panel_machine";
  zone: string;
  x: number;
  y: number;
  width: number;
  height: number;
  capacity: number;
  status: "available" | "in_use" | "maintenance";
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastCastingTables: StructureCastCastingTable[] = [
  // Forms — left section
  {
    id: "sc-ct-1",
    name: "Form 1",
    tableType: "post_form",
    zone: "north",
    x: 3,
    y: 8,
    width: 20,
    height: 36,
    capacity: 6,
    status: "in_use",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-ct-2",
    name: "Form 2",
    tableType: "post_form",
    zone: "north",
    x: 25,
    y: 8,
    width: 20,
    height: 36,
    capacity: 6,
    status: "in_use",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-ct-3",
    name: "Form 3",
    tableType: "post_form",
    zone: "south",
    x: 3,
    y: 56,
    width: 20,
    height: 36,
    capacity: 4,
    status: "available",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  // Lid Tables — right section
  {
    id: "sc-ct-4",
    name: "Form 4",
    tableType: "panel_machine",
    zone: "north",
    x: 55,
    y: 8,
    width: 20,
    height: 36,
    capacity: 6,
    status: "in_use",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-ct-5",
    name: "Form 5",
    tableType: "panel_machine",
    zone: "north",
    x: 77,
    y: 8,
    width: 20,
    height: 36,
    capacity: 4,
    status: "available",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-ct-6",
    name: "Form 6",
    tableType: "panel_machine",
    zone: "south",
    x: 55,
    y: 56,
    width: 20,
    height: 36,
    capacity: 4,
    status: "maintenance",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
];

export const createMockStructureCastCastingTableStore = () =>
  new MockServiceStore<StructureCastCastingTable>({
    mockData: mockStructureCastCastingTables,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-casting-tables",
  });

export default mockStructureCastCastingTables;
